// Funding fase 3+4 (G1 a), reviewronde: wat de lijst op de Funding-tab zegt
// over een regeling die de vindlaan automatisch opnam. Het label stond alleen
// in het detailpaneel; in de lijst leek een niet-nagekeken vondst een gewone
// regeling. De vlaggen komen van de server (sof.funding.vinden.extra_vlaggen):
//   nieuw_niet_nagekeken        — nog door niemand nagekeken
//   vinding:naam_uit_url        — de naam is afgeleid uit het webadres
//   vinding:verstrekker_uit_domein — de verstrekker is het domein van de pagina
//   vinding:geen_sector_van_de_poort — de poort noemde geen sector
//   vinding:sector_onzeker_van_de_poort / vinding:type_onzeker_van_de_poort —
//     de poort moest één optie kiezen en was er niet zeker van (review fase 6)

export const VLAG_NIEUW = "nieuw_niet_nagekeken";

const AFGELEID_TEKST: Record<string, string> = {
  "vinding:naam_uit_url": "naam afgeleid uit het webadres",
  "vinding:verstrekker_uit_domein": "verstrekker afgeleid uit het domein",
  "vinding:geen_sector_van_de_poort": "geen sector bekend",
  // Review fase 6: de poort moest kiezen en was niet zeker.
  "vinding:sector_onzeker_van_de_poort": "sector onzeker",
  "vinding:type_onzeker_van_de_poort": "soort verstrekker onzeker",
};

/** null = gewone regeling; anders de korte tekst voor de lijst. */
export function vondstLabel(vlaggen: readonly string[] | undefined): string | null {
  const v = vlaggen ?? [];
  if (!v.includes(VLAG_NIEUW)) return null;
  const delen = ["nieuw gevonden, nog niet nagekeken"];
  for (const vlag of v) {
    const tekst = AFGELEID_TEKST[vlag];
    if (tekst) delen.push(tekst);
  }
  return delen.join(" · ");
}

// Koppelreparatie (owner-go 08-10-2026): een regeling die geen scholing door
// de werkgever financiert, blijft op de Funding-tab maar draagt haar label
// (contract funding.scope; labels uit config/funding.yaml#assen.scope). Zonder
// veld (een oudere server) of bij `scholing`: geen label.
export const SCOPE_UITLEG =
  "Deze regeling financiert geen scholing door de werkgever (of alleen een budget dat de werknemer zelf aanvraagt). Ze staat hier volledig, maar komt niet in de strook bij skills, trends en kansen.";

export function scopeLabel(
  scope: { waarde: string; label: string } | undefined | null,
): string | null {
  if (!scope || scope.waarde === "scholing") return null;
  return scope.label || scope.waarde;
}

/** Waarom de sectorregel "geen sector" zegt, als de vindlaan dat weet. */
export function geenSectorTekst(vlaggen: readonly string[] | undefined): string {
  return (vlaggen ?? []).includes("vinding:geen_sector_van_de_poort")
    ? "geen sector (de vindlaan kreeg er geen van de poort)"
    : "geen sector";
}
